import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-fraud-notices',
    imports: [],
    templateUrl: './fraud-notices.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './fraud-notices.component.scss',
})
export class FraudNoticesComponent {
    constructor(public modal: NgbActiveModal) {}
}
